const clients = {
    title: "إدارة العملاء",
    clientProfile: "ملف العميل",
    viewClient: "عرض العميل",
    details: "التفاصيل",
    editProfile: "تعديل الملف الشخصي",
    editProfilePageTitle: "تعديل الملف الشخصي",
    editBreadcrumb: "تعديل",
    saveChanges: "حفظ التغييرات",
    profileUpdatedSuccess: "تم تحديث ملف العميل بنجاح.",
    searchPlaceholder: "ابحث عن عميل",
    emptyTitle: "لا يوجد عملاء بعد",
    emptyDescription: "أضف عميلك الأول للبدء.",
    noDataDescription: "عذرًا، لم يتم العثور على أي عملاء.",
    profile: "الملف الشخصي",
    email: "البريد الإلكتروني",
    mobileNumber: "رقم الجوال",
    editClient: "تعديل",
    editClientTitle: "تعديل العميل",
    showingRange: "عرض {from}-{to} من أصل {total} عميل",
    addClient: {
      createClient: "إضافة عميل",
      addClient: "إضافة عميل",
      addNewClientTitle: "إضافة عميل جديد",
      detailsTitle: "التفاصيل",
      name: "الاسم",
      email: "البريد الإلكتروني",
      mobileNumber: "رقم الجوال",
      labels: {
        name: "الاسم",
        email: "البريد الإلكتروني",
        mobileNumber: "رقم الجوال",
      },
      placeholders: {
        name: "أدخل الاسم",
        email: "أدخل البريد الإلكتروني",
        mobileNumber: "أدخل رقم الجوال",
      },
    },
    listClients: {
      clients: "العملاء",
      listClientsBreadcrumb: "إدارة العملاء",
      name: "الاسم",
      email: "البريد الإلكتروني",
      mobile: "رقم الجوال",
      phone: "رقم الهاتف",
      companyName: "اسم الشركة",
    },
  };
  
  export default clients;